module.exports = __webpack_public_path__ + "img/k.fc31692b.jpg";